module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/premier_tablet-eff13b6164566edd199eb76fdaec4d0d.webp";